import { JournalType } from "model/journal.model";

/** ---- Dispatch Types ---- */
export const UPDATE_LIST_JOURNAL = "UPDATE_LIST_JOURNAL";
export const RESET_JOURNAL = "RESET_JOURNAL";

/** ---- Dispatch Interfaces ---- */
interface UpdateListJournal {
  type: typeof UPDATE_LIST_JOURNAL;
  payload: JournalType;
}

interface ResetJournal {
  type: typeof RESET_JOURNAL;
}

export type JournalAction = UpdateListJournal | ResetJournal;
